import { createChainedFunction } from '@material-ui/core';
import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    SimpleShowLayout,
    SearchInput,
    EditButton,
    Show
} from 'react-admin';
import BoolNumField from '../controls/BoolNumField';
import frequent from '../controls/Frequency';
import moment from 'moment'

const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const GetFrequencyText=(freq)=>{
    var result = '';
    for(var item of frequent) {
        if(item.id === freq) {
            result = item.name + '   ';
            break;
        }
    }
    return result;
}

const Frequency = ({record})=>{
    //let freq = frequency ? frequency : [];
    console.log(record && record.cal_frequency ? record.cal_frequency : [])
    let freq = record && record.cal_frequency ? record.cal_frequency : [];
    try{
        freq = JSON.parse(freq)
    }catch(e){
        ;
    }
    
    if(freq ===  null || freq.length ===0 ) return '';
    
    console.log(freq)
    return(
        <>
        {
            freq.map&&freq.map((item, key)=>(
                frequent.map((frItem)=>( frItem.id === item? GetFrequencyText(item) : null)
              )
            )
        )
        }
        </>
    )   
}

const FrequencyMain = ({record})=>{
    //let freq = frequency ? frequency : [];
    console.log(record && record.main_frequency ? record.main_frequency : [])
    let freq = record && record.main_frequency ? record.main_frequency : [];
    try{
        freq = JSON.parse(freq)
    }catch(e){
        ;
    }
    
    if(freq ===  null || freq.length ===0 ) return '';
    
    console.log(freq)
    return(
        <>
        {
            freq.map&&freq.map((item, key)=>(
                frequent.map((frItem)=>( frItem.id === item? GetFrequencyText(item) : null)
              )
            )
        )
        }
        </>
    )   
}

const FrequencyVal = ({record})=>{
    //let freq = frequency ? frequency : [];
    console.log(record && record.val_frequency ? record.val_frequency : [])
    let freq = record && record.val_frequency ? record.val_frequency : [];
    try{
        freq = JSON.parse(freq)
    }catch(e){
        ;
    }
    
    if(freq ===  null || freq.length ===0 ) return '';
    
    console.log(freq)
    return(
        <>
        {
            freq.map&&freq.map((item, key)=>(
                frequent.map((frItem)=>( frItem.id === item? GetFrequencyText(item) : null)
              )
            )
        )
        }
        </>
    )   
}

const FrequencyLog = ({record})=>{
    //let freq = frequency ? frequency : [];
    console.log(record && record.log_frequency ? record.log_frequency : [])
    let freq = record && record.log_frequency ? record.log_frequency : [];
    try{
        freq = JSON.parse(freq)
    }catch(e){
        ;
    }
    
    if(freq ===  null || freq.length ===0 ) return '';
    
    console.log(freq)
    return(
        <>
        {
            freq.map&&freq.map((item, key)=>(
                frequent.map((frItem)=>( frItem.id === item? GetFrequencyText(item) : null)
              )
            )
        )
        }
        </>
    )   
}

export const InstrumentFilters = props => (
    <Filter {...props}>
        <SearchInput source="name" alwaysOn  placeholder='Instrument Name'/>        
    </Filter>
);

const InstShow = props => (
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
    >
        <SimpleShowLayout>
        <table >
            <tbody>
            <tr>
                <th>Instrument Name:</th><td>&nbsp;&nbsp;{props.record && props.record.name}</td>
                <th>Insrument ID:</th><td>&nbsp;&nbsp;{props.record && props.record.ins_id}</td>
            </tr>
            <tr>
                <th>Alt Instrument ID 1:</th><td>&nbsp;&nbsp;{props.record && props.record.alt_id_1}</td>
                <th>Alt Instrument ID 2:</th><td>&nbsp;&nbsp;{props.record && props.record.alt_id_2}</td>
            </tr>
            <tr>
                <th>Manufacture:</th>
                <td>&nbsp;&nbsp;{props.record && props.record.manufacture}</td>
                <th>Serial Number:</th>
                <td>&nbsp;&nbsp;{props.record && props.record.serial_num}</td>
           </tr>
           <tr>
                <th>Make & Model:</th><td>&nbsp;&nbsp;{props.record && props.record.make_model}</td>
                <th>Size:</th><td>&nbsp;&nbsp;{props.record && props.record.ins_size}</td>
           </tr>
           <tr>
                <th>Supplier:</th><td>&nbsp;&nbsp;{props.record && props.record.supplier}</td>
                <td colSpan={2}>&nbsp;</td>
            </tr>
            <tr>
                <th>Purchase Date:</th><td>&nbsp;&nbsp;{props.record && moment(props.record.purchase_dt).format('MM/DD/YYYY')}</td>
                <th>Expire Date:</th><td>&nbsp;&nbsp;{props.record && moment(props.record.expire_dt).format('MM/DD/YYYY') }</td>
            </tr>
            <tr>
                <th>Is Active?</th><td>&nbsp;&nbsp;{props.record && props.record.is_active? '✔' : '✖' }</td>
                <th>Comments:</th><td>&nbsp;&nbsp;{props.record && props.record.comments}</td>
            </tr>
            <tr>
                <th>Calibration:</th><td>&nbsp;&nbsp;{props.record && props.record.is_calibration? '✔' : '✖' }</td>
                <td colSpan={2}><Frequency record={props.record} /></td>
            </tr>
            <tr>
                <th>Maintenance:</th><td>&nbsp;&nbsp;{props.record && props.record.is_maintenance? '✔' : '✖' }</td>
                <td colSpan={2}><FrequencyMain record={props.record} /></td>
            </tr>
            <tr>
                <th>validation:</th><td>&nbsp;&nbsp;{props.record && props.record.is_validation? '✔' : '✖' }</td>
                <td colSpan={2}><FrequencyVal record={props.record} /></td>
            </tr>
            <tr>
                <th>log:</th><td>&nbsp;&nbsp;{props.record && props.record.is_log? '✔' : '✖' }</td>
                <td colSpan={2}><FrequencyLog record={props.record} /></td>
            </tr>
            <tr>
                <th>Is Active?</th><td>&nbsp;&nbsp;{props.record && props.record.is_active? '✔' : '✖'}</td>
                <td colSpan={2}>&nbsp;</td>
            </tr>
           {console.log(props.record)}
            </tbody>
        </table>
        </SimpleShowLayout>
    </Show>
);

export const InstrumentList = props => (
    <List 
        {...props}
        filters={<InstrumentFilters />}
        perPage={20}
        sort={{ field: 'name', order: 'ASC' }}
        bulkActionButtons ={false}
        title= "Instruments"
        >
        <Datagrid   expand={<InstShow />} >               
            <TextField source="name" label="Name" />
            <TextField source="ins_id" label="ID" />
            <BoolNumField  source="is_active" label="Is Active?" />
            <EditButton />
           </Datagrid>
    </List>
);


export default InstrumentList